import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

export interface ContactFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

export interface ContactFormResponse {
  success: boolean;
  message: string;
}

class ContactService {
  private functions = functions;

  async sendContactEmail(data: ContactFormData): Promise<ContactFormResponse> {
    try {
      // Validate required fields
      if (!data.firstName || !data.lastName || !data.email || !data.subject || !data.message) {
        throw new Error('All required fields must be filled');
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(data.email)) {
        throw new Error('Please enter a valid email address');
      }

      const sendContactEmail = httpsCallable(this.functions, 'sendContactEmail');
      const result = await sendContactEmail(data);
      
      return result.data as ContactFormResponse;
    } catch (error: any) {
      console.error('Error sending contact email:', error);
      
      // Handle Firebase function errors
      if (error.code) {
        switch (error.code) {
          case 'functions/invalid-argument':
            throw new Error(error.message || 'Invalid form data provided');
          case 'functions/internal':
            throw new Error('Server error. Please try again later.');
          case 'functions/unavailable':
            throw new Error('Service temporarily unavailable. Please try again later.');
          default:
            throw new Error(error.message || 'Failed to send message. Please try again.');
        }
      }
      
      throw new Error(error.message || 'Failed to send message. Please try again.');
    }
  }
}

export const contactService = new ContactService();
